/** Fiche dont on affiche l'historique, identifiée par son code unique (filtre de `/admin/emails`). */
export type EmailHistorySource = { type: 'company' | 'user'; uniqueCode: string | undefined };

/** Clé de cache de la table, exposée pour l'invalider après un envoi d'e-mail. */
export function getEmailHistoryQueryKey(source: EmailHistorySource) {
  return ['admin-emails', source.type, source.uniqueCode] as const;
}
